export class FiltrosDocumentosNegociables{

   Tipo_Comprobante : string ='';
   Id : string ='';
   Estado : string ='R';
   Tipo_Emision : string ='';
   Adjunto : string ='';
   Numero : string ='';
   user_id:string='';
   IdAdq : string ='';
   
   CodOperacion : string =''; 
   

}
